// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import Paper from '@/modules/common/components/Paper';
import Content from '@/modules/common/components/Content';
import Spinner from '@/modules/common/components/Spinner';
import ErrorFetch from '@/modules/common/components/ErrorFetch';
import Pagination from '@/modules/common/components/Pagination';
import ContentBody from '@/modules/common/components/ContentBody';
import ContentHeader from '@/modules/common/components/ContentHeader';
import { withFetch } from '~/hocs/fetch';
import { withRouter } from '~/hocs/router';
import { formatDate, parseDate } from '~/common';
import Top from './Top';
import Table from './Table';
import '../styles/Journal.scss';

const breadcrumbs = [{name: 'Журнал'}];

const initialValuesFilter = {
    levelno: '',
    created: {from: null, to: null},
    name: '',
    msg: '',
};

const mapValuesFilter = {
    levelno: 'levelno',
    name: 'name',
    msg: 'msg',
};

function isFiltered (urlSearchParams) {
    return (
        urlSearchParams.get('created_from') ||
        urlSearchParams.get('created_to') ||
        Object.entries(mapValuesFilter).some((element) => urlSearchParams.get(element[1]))
    );
}

let abortController;

const Journal = (props) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [valuesFilter, setValuesFilter] = useState(initialValuesFilter);

    const fetch = () => {
        abortController = new AbortController();
        setLoading(true);
        props.fetch.get(`/api/journal/?${props.router.urlSearchParams.toString()}`, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    setData(data);
                }
                setLoading(false);
            })
            .catch((error) => {
                setData(null);
                if (error.name !== 'AbortError') {
                    setLoading(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    useEffect(() => {
        let page = parseInt(props.router.urlSearchParams.get('page'));
        const created_from = parseDate(props.router.urlSearchParams.get('created_from'), 'dd.MM.yy');
        const created_to = parseDate(props.router.urlSearchParams.get('created_to'), 'dd.MM.yy');

        let valuesFilter = {...initialValuesFilter};
        Object.entries(mapValuesFilter).forEach((element) => {
            valuesFilter[element[0]] = props.router.getUrlSearchParam(element[1]);
        });
        valuesFilter.created = {from: created_from, to: created_to};
        setValuesFilter(valuesFilter);

        if (isNaN(page)) {
            page = 1;
        }

        // noinspection JSCheckFunctionSignatures
        props.router.urlSearchParams.set('page', page);

        fetch();
    }, [props.history.location.search]);

    const handleSubmitFilter = (event) => {
        event.preventDefault();
        Object.entries(mapValuesFilter).forEach(([key, value]) => {
            props.router.urlSearchParams.set(value, valuesFilter[key]);
        });
        props.router.urlSearchParams.set('created_from', formatDate(valuesFilter.created.from));
        props.router.urlSearchParams.set('created_to', formatDate(valuesFilter.created.to));
        props.router.urlSearchParams.set('page', '1');
        props.history.push({search: props.router.urlSearchParams.toString()});
    };

    const handleClickResetFilter = () => {
        props.history.push({search: '?page=1'});
    };

    // noinspection JSUnresolvedVariable
    return (
        <Content id="journal">
            <ContentHeader breadcrumbs={breadcrumbs}/>
            <ContentBody><Paper>
                {(!loading)
                    ? <>
                        {(data && data.results)
                            ? <>
                                <Top journal={data.results}
                                     isFiltered={Boolean(isFiltered(props.router.urlSearchParams))}
                                     valuesFilter={valuesFilter} setValuesFilter={setValuesFilter}
                                     onClickResetFilter={handleClickResetFilter}
                                     onSubmitFilter={handleSubmitFilter}
                                />
                                <Table valuesFilter={valuesFilter} setValuesFilter={setValuesFilter}
                                       journal={data.results}
                                />
                                {(data.results.length > 0)
                                    ? <Pagination totalPages={data.total_pages} currentPage={data.current_page}/>
                                    : null
                                }
                            </>
                            : <ErrorFetch onClick={() => fetch()}/>
                        }
                    </>
                    : <Spinner/>
                }
            </Paper></ContentBody>
        </Content>
    );
};

let Component = Journal;
Component = withRouter(Component);
Component = withFetch(Component);

export default Component;
